// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nion-input.custom[data-v-350b4506] {\n    --placeholder-color: #92949c;\n}\n.label-color[data-v-350b4506] {\n    color: #92949c;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
